import type { RouteRecordRaw } from "vue-router"

const Layout = () => import("@/layout/index.vue")
const Handover = () => import("@/layout/components/NavigationBar/HandoverList.vue")
const HandoverLayout = () => import("@/layout/components/NavigationBar/HandoverLayout.vue")
const Bookkeeping = () => import("@/components/Bookkeeping/BookkeepingLayout.vue")
const OperationApprovalTickets = () => import("@/views/page/dashboard/components/SensitiveApproval/SensitiveApprovalTickets.vue")

const globalRoutes: RouteRecordRaw[] = [
  {
    path: "/handover",
    component: Layout,
    children: [
      {
        path: "/handover/history",
        component: Handover,
        meta: {
          title: "交接班记录",
          permissions: ["business_worker_detail"],
        },
      },
      {
        path: "/handover/layout",
        name: 'HandoverLayout',
        component: HandoverLayout,
        meta: {
          permissions: ["business_worker"],
        },
      },
      {
        path: "/handover/detail/:id",
        component: () => import("@/layout/components/NavigationBar/HandoverDetail.vue"),
        name: "HandoverDetail",
        props: true,
        meta: {
          permissions: ["business_worker_detail"],
        },
      },
    ],
    meta: {
      hidden: true,
      permissions: ["business_worker"],
    },
  },
  {
    path: "/operation-approval",
    component: Layout,
    redirect: "/operation-approval/index",
    children: [
      {
        path: "/operation-approval/index",
        name: "AccessibleOperationApprovalTickets",
        component: OperationApprovalTickets,
        meta: {
          title: "操作审核",
          hidden: true,
        },
      },
    ],
    meta: {
      hidden: true,
    },
  },
  {
    path: "/bookkeeping",
    component: Layout,
    children: [
      {
        path: "/bookkeeping/index",
        component: Bookkeeping,
        meta: {
          title: "记账本",
          permissions: ["business_accounting"],
        },
      },
    ],
    meta: {
      hidden: true,
      permissions: ["business_accounting"],
    },
  },
]
export default globalRoutes
